import { ExternalLink, HelpCircle } from 'lucide-react'
import { usePermissions } from '@/modules/auth/hooks/usePermissions'

const HELP_LINKS = {
  admin: {
    url: 'https://fernandogutz.notion.site/Gu-as-Admin-Club-fbb66cd45b2c4b35a41dc040eb900218',
    label: 'Manual de uso de la plataforma (Admin)',
  },
  user: {
    url: 'https://fernandogutz.notion.site/Gu-as-para-Vendedores-Software-Club-0f42ffa704144fb993f4c327de02ec71?pvs=74',
    label: 'Manual de uso de la plataforma',
  },
}

export function HelpPage() {
  const { isAdmin } = usePermissions()
  const link = isAdmin ? HELP_LINKS.admin : HELP_LINKS.user

  return (
    <div className="max-w-2xl">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Ayuda</h1>

      <div className="card p-6">
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0 w-12 h-12 rounded-full bg-primary-50 flex items-center justify-center">
            <HelpCircle size={24} className="text-primary-600" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">
              ¿Necesitas ayuda?
            </h2>
            <p className="text-gray-600 mb-4">
              Consulta nuestro manual de uso para resolver tus dudas sobre la plataforma.
            </p>
            <a
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary inline-flex items-center gap-1.5"
            >
              <ExternalLink size={16} />
              {link.label}
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
